import React from 'react';
import { useSelector } from 'react-redux';
import css from './spinner.scss';

const Spinner = () => {
  const { spinnerReducer } = useSelector(state => state);
  const ticks = [];
  for (let i = 0; i < 12; i += 1) {
    ticks.push(<div className={css['spinner-tick']} key={`tick-${i}`} />);
  }
  return (
    <React.Fragment>
      {spinnerReducer.length > 0 && <div className={css['spinner-overlay']}>
        <div className={css.spinner} >
          {ticks}
        </div>
      </div>}
    </React.Fragment>
  );
};

export default Spinner;
